import classes from "../field/Field.module.css";

const Search = (props) => {
  return (
    <div className={classes.templateFilterSearch}>
      <div className={classes.labelInfo}>
        <label>Search</label>
      </div>
      <div className={classes.formInputContainer}>
        <input
          htmlFor="search"
          type="text"
          className={classes.formInput}
          onChange={props.onSearch}
        />
      </div>
    </div>
  );
};

export default Search;
